{
  "title": "True Resurrection",
  "source": "Player's Handbook",
  "levelAndSchool": "9th-level necromancy",
  "level": 9,
  "castingTime": "1 hour",
  "range": "Touch",
  "components": "V, S, M (a sprinkle of holy water and diamonds worth at least 25,000 gp, which the spell consumes)",
  "duration": "Instantaneous",
  "description": [
    "You touch a creature that has been dead for no longer than 200 years and that died for any reason except old age. If the creature’s soul is free and willing, the creature is restored to life with all its hit points.",
    "This spell closes all wounds, neutralizes any poison, cures all diseases, and lifts any curses affecting the creature when it died. The spell replaces damaged or missing organs or limbs. If the creature was undead, it is restored to its non-undead form.",
    "The spell can even provide a new body if the original no longer exists, in which case you must speak the creature’s name. The creature then appears in an unoccupied space you choose within 10 feet of you."
  ],
  "spellLists": ["cleric", "druid"]
}
